var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.variableToVisualize}},[_c('div',{attrs:{"id":"introViz"}}),_c('div',{staticClass:"ttp ttpUSA elevation-1"})])}
var staticRenderFns = []

export { render, staticRenderFns }